package com.appsyde.shared.presentation.screen.component.menu

import com.appsyde.shared.modules.ticket.domain.model.Direction
import com.appsyde.shared.modules.ticket.domain.model.MessageAttachment

/** Document pour la card Documents : pièce jointe + message d'origine (date, URL, direction). */
data class SidebarDocument(
    val attachment: MessageAttachment,
    val messageId: String,
    val sentAtMs: Long,
    /** INBOUND = reçu, OUTBOUND = envoyé (pour afficher ⬇ / ⬆). */
    val direction: Direction = Direction.UNKNOWN
)
